import lang from '@/lang';

const locale = window.navigator.userLanguage || window.navigator.language;
let language = locale.substr(0, 2);
if (!lang[language]) {
  language = 'en';
}

export default {
  env: process.env.NODE_ENV,
  apiRoot: process.env.VUE_APP_API_ROOT,
  accountLogosRoot: process.env.VUE_APP_ACCOUNT_LOGOS_ROOT,
  appMode: process.env.VUE_APP_MODE,
  lang: language,
};
